import { Component, Input, Output, EventEmitter } from '@angular/core';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { PageNotificationService } from '@signature-it/ngx-generic/services';
import { CartService } from '@signature-it/ngx-catalogue/services';

declare let _: any;

@Component({
    selector: 'cart-orders-actions',
    templateUrl: './actions.html',
    styleUrls: ['./actions.scss'],
    standalone: false
})
export class CartOrdersActionsComponentGeneric {
    cartLink = GenericConfig.orderType == "rfq" ? "/rfq" : "/cart";
    @Input('config') config = {
        showEdit: false,
        showClearAll: true,
        showUpdateAll: false
    };
    @Output() clearAll = new EventEmitter();
    @Output() updateAll = new EventEmitter();
    @Output() editCart = new EventEmitter();

	constructor(protected notifySvc: PageNotificationService,
                protected cartSvc: CartService) {}

    onRemoveAll() {
        this.clearAll.next(true);
    }

    onUpdateAll() {
	    this.updateAll.next(true);
    }

    onEditCart() {
	    this.editCart.next(true);
    }

}
